import { CodeBasedRef } from '@/app/network/models/refs';
import { DisplayValue } from '@/common/components/display-value';

type AddressDisplayValueProps = {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: CodeBasedRef;
  zipCode?: string;
};

export function AddressDisplayValue({
  addressLine1,
  addressLine2,
  city,
  state,
  zipCode
}: AddressDisplayValueProps) {
  const addressParts = [addressLine1, addressLine2, city, state?.name, zipCode].filter(Boolean);

  return (
    <DisplayValue
      value={addressParts.length > 0 ? 'has-address' : ''}
      renderer={() => {
        const parts = [];
        if (addressLine1) parts.push(<div key="address-line-1">{addressLine1}</div>);
        if (addressLine2) parts.push(<div key="address-line-2">{addressLine2}</div>);

        const cityStateZip = [city, state?.name, zipCode].filter(Boolean);
        if (cityStateZip.length > 0) {
          parts.push(<div key="city-state-zip">{cityStateZip.join(', ')}</div>);
        }

        return <div className="space-y-1">{parts}</div>;
      }}
    />
  );
}
